import { ButtonGroup } from "@pdfking/components"
import { MinusIcon, PlusIcon } from "lucide-react"

import { TooltipIconButton } from "../../components/TooltipIconButton"
import { useTranslationTyped } from "../../i18n/useTranslation"

// The -/+ pair at the right edge of an array row header, absolutely
// positioned over the full row height and self-centered — the label columns
// keep their own flex layout (staying aligned with the field columns below).
export function ArrayControls({
  can_add,
  can_remove,
  on_add,
  on_remove,
}: {
  can_add: boolean
  can_remove: boolean
  on_add: () => void
  on_remove: () => void
}) {
  const actions = useTranslationTyped("actions")
  const stop = (fn: () => void) => (e: MouseEvent) => {
    e.preventDefault()
    fn()
  }
  return (
    <ButtonGroup className="absolute right-0 top-1/2 -translate-y-1/2">
      <TooltipIconButton
        className="h-5 rounded-r-none"
        disabled={!can_remove}
        onClick={stop(on_remove)}
        side="left"
        tabindex={-1}
        title={actions.DELETE()}
      >
        <MinusIcon />
      </TooltipIconButton>
      <TooltipIconButton
        className="h-5 rounded-l-none border-l-0"
        disabled={!can_add}
        onClick={stop(on_add)}
        side="right"
        tabindex={-1}
        title={actions.ADD()}
      >
        <PlusIcon />
      </TooltipIconButton>
    </ButtonGroup>
  )
}
